/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Conn_Not_ConnectedInputs */

const cs_ebr_conn_not_connected = /** @type {(inputs: Ebr_Conn_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepřipojeno`)
};

const en_ebr_conn_not_connected = /** @type {(inputs: Ebr_Conn_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not connected`)
};

/**
* | output |
* | --- |
* | "Not connected" |
*
* @param {Ebr_Conn_Not_ConnectedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conn_not_connected = /** @type {((inputs?: Ebr_Conn_Not_ConnectedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conn_Not_ConnectedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conn_not_connected(inputs)
	return cs_ebr_conn_not_connected(inputs)
});